/**
 * @param    {string}   sColor  [十六进制色值]
 * @param    {float}    opacity [透明度]
 */
export const colorRgb = (sColor, opacity) => {
	sColor = sColor.toLowerCase();
	//十六进制颜色值的正则表达式
	var reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/;
	// 如果是16进制颜色
	if(sColor && reg.test(sColor)) {
		if(sColor.length === 4) {
			var sColorNew = "#";
			for(var i = 1; i < 4; i += 1) {
				sColorNew += sColor.slice(i, i + 1).concat(sColor.slice(i, i + 1));
			}
			sColor = sColorNew;
		}
		//处理六位的颜色值
		var sColorChange = [];
		for(var i = 1; i < 7; i += 2) {
			sColorChange.push(parseInt("0x" + sColor.slice(i, i + 2)));
		}
		return "RGB(" + sColorChange.join(",") + "," + opacity + ")";
	}
	return sColor;
};

/**
 * @更改主题色
 *
 * 通过root定义变量
 * step:
 *  1、var.scss中定义初始变量
 *  2、themeLocal字典映射（存放需要替换的色值）
 */
export const setColorByRoot = (theme) => {
	const {
		basecolor
	} = theme;
	const themeLocal = {
		'--base-color': basecolor,
		'--base-color-light': colorRgb(basecolor, 0.15),
	}
	for(let [key, value] of Object.entries(themeLocal)) {
		document.getElementsByTagName('body')[0].style.setProperty(key, value);
	}
}


// WEBPACK FOOTER //
// ./src/common/js/theme.js